"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BtnWhatsapp_vue_1 = __importDefault(require("./BtnWhatsapp.vue"));
const SocialShare_vue_1 = __importDefault(require("./SocialShare.vue"));
const BtnFavorito_vue_1 = __importDefault(require("./BtnFavorito.vue"));
const InmuebleMapa_vue_1 = __importDefault(require("./ficha/InmuebleMapa.vue"));
const SucursalesMapa_vue_1 = __importDefault(require("./sucursales/SucursalesMapa.vue"));
const InmuebleVideos_vue_1 = __importDefault(require("./ficha/InmuebleVideos.vue"));
const InmuebleGaleria_vue_1 = __importDefault(require("./ficha/InmuebleGaleria.vue"));
const BuscadorHorizontal_vue_1 = __importDefault(require("./buscador/BuscadorHorizontal.vue"));
const BusquedasSugeridas_vue_1 = __importDefault(require("./home/BusquedasSugeridas.vue"));
const ResultadosBusqueda_vue_1 = __importDefault(require("./resultados/ResultadosBusqueda.vue"));
const SuscripcionNewsletter_vue_1 = __importDefault(require("./home/SuscripcionNewsletter.vue"));
exports.default = {
    BtnWhatsapp: BtnWhatsapp_vue_1.default,
    SocialShare: SocialShare_vue_1.default,
    BtnFavorito: BtnFavorito_vue_1.default,
    InmuebleMapa: InmuebleMapa_vue_1.default,
    SucursalesMapa: SucursalesMapa_vue_1.default,
    InmuebleVideos: InmuebleVideos_vue_1.default,
    InmuebleGaleria: InmuebleGaleria_vue_1.default,
    BuscadorHorizontal: BuscadorHorizontal_vue_1.default,
    ResultadosBusqueda: ResultadosBusqueda_vue_1.default,
    BusquedasSugeridas: BusquedasSugeridas_vue_1.default,
    SuscripcionNewsletter: SuscripcionNewsletter_vue_1.default
};
